// Mein Heldenkind - plain JS for every page (source; the build lands in static/web/js/app.js).
// Each area brings its own module:

require('./wizard');    // the create wizard /erstellen/ (BOOK)
require('./photopick');   // a photo later on the unpaid book page (BOOK; wizard + book.js use it too)
require('./shop');   // the buy panel's running total (SHOP)
require('./landing');   // landing + marketing pages: name demo, cycles, reveal (SITE)
require('./spreads');   // static book spreads on example pages + So geht's: fit the text like the book (SITE)
window.mhTracking = require('./tracking');   // cookie banner + GA4/Clarity after consent (SHOP)
window.mhTracking.start();
